import { Col, Row } from 'react-bootstrap';
import WardProfileCard from '../components/admin/wards/wardDetail/WardProfileCard';
import AdminLayout from './layout/AdminLayout';

const WardDetail = () => {

    return (
        <AdminLayout>
            <Row>
                <Col className='container'>
                    <WardProfileCard />
                </Col>
            </Row>
        </AdminLayout>
    )
}

export default WardDetail;